import {customAxios as axios, getToken} from "../../../request";
import {
    getAllBranchUrl,
    getMedicineReportUrl,
    getOpdReportUrl,
    getPaidReportUrl,
    getServiceReportUrl,
    getStockValuationUrl, getSummaryUrl, getVisitFollowupsUrl
} from "../apis";

export const getServiceReportFxn = async (valData) => {
    let {data} = await axios.post(getServiceReportUrl(), valData, getToken());
    return data
}
export const getOpdReportFxn = async (valData) => {
    let {data} = await axios.post(getOpdReportUrl(), valData, getToken());
    return data
}
export const getMedicineReportFxn = async (valData) => {
    let {data} = await axios.post(getMedicineReportUrl(), valData, getToken());
    return data
}
export const getPaidReportFxn = async (valData) => {
    let {data} = await axios.post(getPaidReportUrl(), valData, getToken());
    return data
}
export const getStockValuationFxn = async (valData) => {
    let {data} = await axios.post(getStockValuationUrl(), valData, getToken());
    return data
}
export const getSummaryFxn = async (valData) => {
    let {data} = await axios.post(getSummaryUrl(), valData, getToken());
    return data
}
export const getVisitFollowupsFxn = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    let {data} = await axios.get(getVisitFollowupsUrl(), config);
    return data
}

export const getAllBranchFxn = async (valData) => {
    let {data} = await axios.post(getAllBranchUrl(), valData, getToken());
    return data
}